var map = {
	"./desktop-image-hero-1.jpg": 479,
	"./desktop-image-hero-2.jpg": 4738,
	"./desktop-image-hero-3.jpg": 6714,
	"./favicon-32x32.png": 9900,
	"./icon-angle-left.svg": 7718,
	"./icon-angle-right.svg": 9648,
	"./icon-arrow.svg": 7967,
	"./icon-close.svg": 1924,
	"./icon-hamburger.svg": 4422,
	"./image-about-dark.jpg": 1761,
	"./image-about-light.jpg": 7497,
	"./logo.svg": 2835,
	"./mobile-image-hero-1.jpg": 9902,
	"./mobile-image-hero-2.jpg": 605,
	"./mobile-image-hero-3.jpg": 9320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;